
import React, { useEffect, useState } from 'react';
import PageTitle from '../../layouts/PageTitle';
import { getEditStaffApi, UpdateStaffApi } from '../../../services/apis/EventMangement/EventStaffApi';
import { getCityApi, getCountryApi, getStateApi } from '../../../services/apis/EventMangement/CountryStateCityApi';
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useParams } from 'react-router-dom';

const EditStaff = () => {
    const editId = useParams()?.id

    const [formValues, setFormValues] = useState({
        profile_picture: null,
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        country: '',
        state: '',
        city: '',
        zipcode: '',
        address: '',
        pan_number: '',
        aadhar_number: '',
        pan_front: null,
        aadhar_front: null,
        aadhar_back: null,
    });

    const [countriesList, setCountriesList] = useState([]);
    const [stateList, setStateList] = useState([]);
    const [cityList, setCityList] = useState([]);


    const [formErrors, setFormErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValues({ ...formValues, [name]: value });
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setFormValues({ ...formValues, [name]: files[0] });
    };

    const validate = () => {
        let errors = {};
        if (!formValues.firstname) errors.firstname = 'First name is required';
        if (!formValues.lastname) errors.lastname = 'Last name is required';
        if (!formValues.email) errors.email = 'Email is required';
        if (!formValues.phone) errors.phone = 'Phone is required';
        if (!formValues.country) errors.country = 'Country is required';
        if (!formValues.state) errors.state = 'State is required';
        if (!formValues.city) errors.city = 'City is required';
        if (!formValues.zipcode) errors.zipcode = 'Zip code is required';
        if (!formValues.address) errors.address = 'Address is required';
        if (!formValues.pan_number) errors.pan_number = 'PAN number is required';
        if (!formValues.aadhar_number) errors.aadhar_number = 'Aadhar number is required';
        if (!formValues.pan_front) errors.pan_front = 'PAN front image is required';
        if (!formValues.aadhar_front) errors.aadhar_front = 'Aadhar front image is required';
        if (!formValues.aadhar_back) errors.aadhar_back = 'Aadhar back image is required';
        return errors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const errors = validate();
        if (Object.keys(errors).length === 0) {

            try {
                const { confirmPassword, ...apiData } = formValues;

                const response = await UpdateStaffApi(editId, apiData);

                if (response.data.success) {
                    toast.success(response.data.message)
                }
            } catch (error) {

                if (!error.response.data.success) {
                    toast.error(error.response.data.message)
                }
            }
        } else {
            setFormErrors(errors);
        }
    };

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const countriesResponse = await getCountryApi();
                setCountriesList(countriesResponse.data?.countries);

                if (formValues?.country) {
                    const statesResponse = await getStateApi(formValues.country);
                    setStateList(statesResponse?.data?.states);
                }

                if (formValues?.state) {
                    const citiesResponse = await getCityApi(
                        formValues.country,
                        formValues.state
                    );
                    setCityList(citiesResponse?.data?.cities);
                }
            } catch (error) {
                console.log(error.message);
            }
        };

        fetchInitialData();
    }, [formValues?.country, formValues?.state]);



    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getCityApi(formValues?.country, formValues?.state);
                setCityList(response?.data?.cities);
            } catch (error) {
                console.log(error.message);
            }
        };
        if (formValues?.state) {
            fetchData();
        }
    }, [formValues?.state])


    useEffect(() => {
        if (editId) {
            const fetchEditData = async () => {
                try {
                    const response = await getEditStaffApi(editId);
                    setFormValues(response?.data?.data[0]);
                } catch (error) {
                    toast.error("Failed to fetch edit data");
                }
            };

            fetchEditData();
        }
    }, [editId]);

    return (
        <>
            <ToastContainer />
            <PageTitle activeMenu={"Add Staff"} motherMenu={"Staff"} />
            <div className="row">
                <div className="col-xl-12 col-xxl-12 col-sm-12">
                    <div className="card">
                        <div className="card-header">
                            <h5 className="card-title">Basic Info</h5>
                        </div>
                        <div className="card-body">
                            <form onSubmit={handleSubmit} id="addStaffForm">
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="profile_picture" className="form-label">Profile Picture</label>
                                            <input
                                                name="profile_picture"
                                                type="file"
                                                className="form-control"
                                                onChange={handleFileChange}
                                            />
                                            {formErrors.profile_picture && <small className="text-danger">{formErrors.profile_picture}</small>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    {/* First Name */}
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="firstname" className="form-label">First Name</label>
                                            <input
                                                placeholder="Enter First Name"
                                                name="firstname"
                                                type="text"
                                                className="form-control"
                                                value={formValues.firstname}
                                                onChange={handleChange}
                                            />
                                            {formErrors.firstname && <small className="text-danger">{formErrors.firstname}</small>}
                                        </div>
                                    </div>

                                    {/* Last Name */}
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="lastname" className="form-label">Last Name</label>
                                            <input
                                                placeholder="Enter Last Name"
                                                name="lastname"
                                                type="text"
                                                className="form-control"
                                                value={formValues.lastname}
                                                onChange={handleChange}
                                            />
                                            {formErrors.lastname && <small className="text-danger">{formErrors.lastname}</small>}
                                        </div>
                                    </div>

                                    {/* Email */}
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="email" className="form-label">Email</label>
                                            <input
                                                placeholder="Enter Email"
                                                name="email"
                                                type="email"
                                                className="form-control"
                                                value={formValues.email}
                                                onChange={handleChange}
                                            />
                                            {formErrors.email && <small className="text-danger">{formErrors.email}</small>}
                                        </div>
                                    </div>

                                    {/* Email */}
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="phone" className="form-label">Phone</label>
                                            <input
                                                placeholder="Enter Phone"
                                                name="phone"
                                                type="number"
                                                className="form-control"
                                                value={formValues.phone}
                                                onChange={handleChange}
                                            />
                                            {formErrors.phone && <small className="text-danger">{formErrors.phone}</small>}
                                        </div>
                                    </div>

                                    <div className="row">
                                        {/* Country */}
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <label htmlFor="country" className="form-label">Country</label>
                                                <select className="form-control" name="country" onChange={handleChange}>
                                                    <option >Select Country</option>
                                                    {countriesList.map((value) => (
                                                        <option value={value?.id} selected={value?.id === formValues?.country}>{value?.name}</option>
                                                    ))}
                                                </select>

                                                {formErrors.country && <small className="text-danger">{formErrors.country}</small>}
                                            </div>
                                        </div>

                                        {/* State */}
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <label htmlFor="state" className="form-label">State</label>
                                                <select className="form-control" name="state" onChange={handleChange}>
                                                    <option >Select State</option>
                                                    {stateList.map((value) => (
                                                        <option value={value?.id} selected={value?.id === formValues?.state}>{value?.name}</option>
                                                    ))}
                                                </select>

                                                {formErrors.state && <small className="text-danger">{formErrors.state}</small>}
                                            </div>
                                        </div>

                                        {/* City */}
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <label htmlFor="city" className="form-label">City</label>
                                                <select className="form-control" name="city" onChange={handleChange}>
                                                    <option >Select City</option>
                                                    {cityList.map((value) => (
                                                        <option value={value?.id} selected={value?.id === formValues?.city}> {value?.name}</option>
                                                    ))}
                                                </select>

                                                {formErrors.city && <small className="text-danger">{formErrors.city}</small>}
                                            </div>
                                        </div>

                                        {/* ZIP Code */}
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <label htmlFor="zipcode" className="form-label">Zip Code</label>
                                                <input
                                                    placeholder="Enter Zip Code"
                                                    name="zipcode"
                                                    type="number"
                                                    className="form-control"
                                                    value={formValues.zipcode}
                                                    onChange={handleChange}
                                                />
                                                {formErrors.zipcode && <small className="text-danger">{formErrors.zipcode}</small>}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Address */}
                                    <div className="col-lg-12 col-md-12 col-sm-12">
                                        <div className="form-group">
                                            <label htmlFor="address" className="form-label">Address</label>
                                            <textarea
                                                rows="6"
                                                name="address"
                                                className="form-control"
                                                placeholder="Enter Address"
                                                value={formValues.address}
                                                onChange={handleChange}
                                            ></textarea>
                                            {formErrors.address && <small className="text-danger">{formErrors.address}</small>}
                                        </div>
                                    </div>

                                    {/* PAN Number */}
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="pan_number" className="form-label">PAN Number</label>
                                            <input
                                                placeholder="Enter PAN Number"
                                                name="pan_number"
                                                type="text"
                                                className="form-control"
                                                value={formValues.pan_number}
                                                onChange={handleChange}
                                            />
                                            {formErrors.pan_number && <small className="text-danger">{formErrors.pan_number}</small>}
                                        </div>
                                    </div>

                                    {/* Aadhar Number */}
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="aadhar_number" className="form-label">Aadhar Number</label>
                                            <input
                                                placeholder="Enter Aadhar Number"
                                                name="aadhar_number"
                                                type="text"
                                                className="form-control"
                                                value={formValues.aadhar_number}
                                                onChange={handleChange}
                                            />
                                            {formErrors.aadhar_number && <small className="text-danger">{formErrors.aadhar_number}</small>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    {/* PAN Front */}
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="pan_front" className="form-label">PAN Front</label>
                                            <input
                                                name="pan_front"
                                                type="file"
                                                className="form-control"
                                                onChange={handleFileChange}
                                            />
                                            {formErrors.pan_front && <small className="text-danger">{formErrors.pan_front}</small>}
                                        </div>
                                    </div>

                                    {/* Aadhar Front */}
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="aadhar_front" className="form-label">Aadhar Front</label>
                                            <input
                                                name="aadhar_front"
                                                type="file"
                                                className="form-control"
                                                onChange={handleFileChange}
                                            />
                                            {formErrors.aadhar_front && <small className="text-danger">{formErrors.aadhar_front}</small>}
                                        </div>
                                    </div>

                                    {/* Aadhar Back */}
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="aadhar_back" className="form-label">Aadhar Back</label>
                                            <input
                                                name="aadhar_back"
                                                type="file"
                                                className="form-control"
                                                onChange={handleFileChange}
                                            />
                                            {formErrors.aadhar_back && <small className="text-danger">{formErrors.aadhar_back}</small>}
                                        </div>
                                    </div>
                                </div>

                                {/* Submit and Cancel */}
                                <div className="col-lg-12 col-md-12 col-sm-12 d-flex justify-content-end gap-3">
                                    <button type="button" className="btn btn-danger light">Cancel</button>
                                    <button type="submit" className="btn btn-primary me-1">Submit</button>

                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EditStaff;
